import { lazy } from "react";
import { ALLOWED_MODULES } from "../../constants/enums";
import Loadable from "../../layout/fullLayout/loadable/loadable";
import { AuthorizedRoute } from "../../router/AuthorizedRoute";
import { DISPOSITION_ROUTE } from "./disposition.constant";

const DispositionList = Loadable(
	lazy(() =>
		import("./DispositionList").then(({ DispositionList }) => ({
			default: DispositionList,
		}))
	)
);

const ManageDisposition = Loadable(
	lazy(() =>
		import("./ManageDisposition").then(({ ManageDisposition }) => ({
			default: ManageDisposition,
		}))
	)
);

export const dispositionRoutes = [
	{
		path: DISPOSITION_ROUTE,
		exact: true,
		element: (
			<AuthorizedRoute
				
				moduleIds={[ALLOWED_MODULES.DISPOSITION]}
			>
				<DispositionList />
			</AuthorizedRoute>
		),
	},
	{
		path: `${DISPOSITION_ROUTE}/manage`,
		exact: true,
		element: (
			<AuthorizedRoute
				
				moduleIds={[ALLOWED_MODULES.DISPOSITION]}
			>
				<ManageDisposition />
			</AuthorizedRoute>
		),
	},
	{
		path: `${DISPOSITION_ROUTE}/manage/:uuid`,
		exact: true,
		element: (
			<AuthorizedRoute
					
				moduleIds={[ALLOWED_MODULES.DISPOSITION]}
			>
				<ManageDisposition />
			</AuthorizedRoute>
		),
	},
];
